import { render, staticRenderFns } from "./SkeletonTypePrototypeList.vue?vue&type=template&id=329a6b80&"
import script from "./SkeletonTypePrototypeList.vue?vue&type=script&lang=js&"
export * from "./SkeletonTypePrototypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports